import { render, staticRenderFns } from "./ServicePaymentDetails.vue?vue&type=template&id=05fdf630&scoped=true&"
import script from "./ServicePaymentDetails.vue?vue&type=script&lang=js&"
export * from "./ServicePaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServicePaymentDetails.vue?vue&type=style&index=0&id=05fdf630&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fdf630",
  null
  
)

export default component.exports